// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3xlgm","footer":"ModalError_footer__xNqnN"};